import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 再リース及び満了のENUM */
enum ReLeaseAndContractExpiredType {
  /** 契約を再リースする */
  contractRelease = '1',
  /** 契約を満了する */
  contractExpired = '2',
}

const nameConfig = {
  contractRelease: new Map([[Locale.ja, '契約を再リースする']]),
  contractExpired: new Map([[Locale.ja, '契約を満了する']]),
};

const toEnum = rawValueToEnum(ReLeaseAndContractExpiredType, ReLeaseAndContractExpiredType.contractRelease);
const toDisplay = enumToName(ReLeaseAndContractExpiredType, nameConfig);
const toDisplayWithPrefix = enumToName(ReLeaseAndContractExpiredType, nameConfig, { prefix: true });

export const reLeaseAndContractExpiredType = {
  enum: ReLeaseAndContractExpiredType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ReLeaseAndContractExpiredType };
